// src/api/prepClient.js
import api from "./api"; // your axios instance with auth headers

// Upload study material
export const uploadPrepMaterial = async (formData) => {
  const res = await api.post("/prep/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// Fetch all materials
export const getPrepMaterials = async () => {
  const res = await api.get("/prep");
  return res.data;
};

// Delete a material
export const deletePrepMaterial = async (id) => {
  const res = await api.delete(`/prep/${id}`);
  return res.data;
};

// ✅ Update material (title/notes)
export const updatePrepMaterial = async (id, payload) => {
  const res = await api.put(`/prep/${id}`, payload);
  return res.data;
};
